export default __webpack_public_path__ + "static/media/favicon.fd82ac26.ico";